import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useRequestInvoice from "./useRequestInvoice";
import RequestInvoiceSuperOrderForm from "@beeldit/ecommerce/super-orders/components/RequestInvoiceSuperOrderForm";
import {RequestInvoiceActionContext} from "@beeldit/ecommerce/super-orders/actions/request-invoice/RequestInvoiceActionContext";

function useRequestInvoiceAction(onSuccess: any): any {

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
    onSuccess(); // We pass the function to refresh the table on success
  };

  const showModalRequestInvoice = (element: any) => {
    setElement(element);
    setShowModal(true);
  };

  const requestInvoice = useRequestInvoice();
  const requestInvoiceFunction = () => requestInvoice(onSuccessUpdate);

  const contextInstance = useContext(RequestInvoiceActionContext);
  const { element, setElement, setShowModal } = contextInstance;


  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "request_invoice",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    size: "modal-lg",
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      requestInvoiceFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: RequestInvoiceActionContext,
    action: 'edit',
    className: "super-order-request-invoice-form",
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <RequestInvoiceSuperOrderForm formConfig={formConfig} />
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    showModalRequestInvoice,
    actionTemplate,
  };
}

export default useRequestInvoiceAction;
